import { SYNC_FAILED, SYNC_FINISHED, SYNC_INITIATED, SET_DEVICES } from './actionTypes';
import { IFailedSyncAction, ISetDevicesAction, IDeviceAction, IDeviceState } from './types';

export const initialState = {
  error: null,
  loaded: false,
  devices: [],
  syncing: 0,
};

export const reducer = (
  state: IDeviceState = initialState,
  action: IDeviceAction
): IDeviceState => {
  switch (action.type) {
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    case SYNC_FINISHED:
      return { ...state, syncing: state.syncing - 1 };
    case SYNC_INITIATED:
      return { ...state, error: null, syncing: state.syncing + 1 };
    case SET_DEVICES:
      return {
        ...state,
        loaded: true,
        devices: (action as ISetDevicesAction).payload,
      };
    default:
      return state;
  }
};
